import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentUser, selectIsCustomer } from '@components/Auth';
import { mergeInitialValues } from '@utils/formik';
import { FormValuesForCreate, useFormParams, useFormValues } from '@components/HealthQuoteBuyRoute/HealthQuoteBuyForm';

import { selectCancerQuoteBuyRoute } from '../selector';

export const useInitialValues = () => {
  const currentUser = useSelector(selectCurrentUser);
  const isCustomer = useSelector(selectIsCustomer);
  const { cancerQuote } = useSelector(selectCancerQuoteBuyRoute);
  const params = useFormParams();
  const values = useFormValues();
  const valuesForCreate: FormValuesForCreate = { ...values, planId: '', activationDate: '' };
  return useMemo(() => {
    if (!currentUser) return;
    if (!cancerQuote) return;
    const { members, cancerPlanId } = cancerQuote;
    return mergeInitialValues(
      valuesForCreate,
      isCustomer ? { me: currentUser } : undefined,
      { ...cancerQuote, ...members, planId: cancerPlanId },
      params
    );
  }, [currentUser, cancerQuote]);
};
